import { render, staticRenderFns } from "./AlertaPrecoList.vue?vue&type=template&id=ee8c6574"
import script from "./AlertaPrecoList.vue?vue&type=script&lang=js"
export * from "./AlertaPrecoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports